import React from 'react';
import SearchWidget from '../../../shared/components/SearchWidget';

const mealsList = [
  {
    id: 0,
    name: 'Любое питание',
    fullname: 'Любое питание',
    russian: 'Любое питание',
    russianfull: 'Любое питание',
  },
  {
    id: 2,
    name: 'RO',
    fullname: 'Room Only',
    russian: 'Без питания',
    russianfull: 'Без питания',
  },
  {
    id: 3,
    name: 'BB',
    fullname: 'Bed&Breakfast',
    russian: 'Завтрак',
    russianfull: 'BB - Только завтрак',
  },
  {
    id: 4,
    name: 'HB',
    fullname: 'Half Board',
    russian: 'Полупансион',
    russianfull: 'HB - Завтрак, Ужин',
  },
  {
    id: 5,
    name: 'FB',
    fullname: 'Full Board',
    russian: 'Завтрак, обед, ужин',
    russianfull: 'FB - Завтрак, обед, ужин',
  },
  {
    id: 7,
    name: 'AI',
    fullname: 'All Inclusive',
    russian: 'Все Включено',
    russianfull: 'AI - Все Включено',
  },
  {
    id: 9,
    name: 'UAI',
    fullname: 'Ultra All Inclusive',
    russian: 'Ультра Все Вкл',
    russianfull: 'UAI - Ультра Все Включено',
  },
];

const Meals = ({ value, onChoose }) => {
  const items = mealsList.map((meal) => {
    return { id: meal.id || 0, name: meal.russianfull };
  });
  let meal = items.find((item) => item.id === Number(value));
  const title = meal
    ? meal.id > 2
      ? `${mealsList.find((m) => Number(m.id) === Number(meal.id)).name} и лучше`
      : meal.name
    : 'выберите тип питания';
  const wasChange = !value ? false : true;

  return (
    <SearchWidget
      type="select"
      cssClass="meals"
      label="тип питания"
      title={`${title}`}
      items={items}
      value={value}
      buttonDone={false}
      isChanged={wasChange}
      onChoose={onChoose}
    />
  );
};

export default Meals;
